'use client';

import { useEffect, useState } from 'react';

import { searchEmptyList } from 'constants/listPredefinedDates';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';
import { convertObjectToQueryParam } from 'utils/misc';

import locationStore from 'stores/LocationStore';
import Link from 'next/link';
import { IconTime } from '@sympla/sympla-components';
import * as styles from './SearchList.css';

function SearchEmptyList({
  closedDropdown,
  lastSearches,
  updateLastSearches,
}: {
  closedDropdown: () => void;
  lastSearches?: string[];
  updateLastSearches?: (text: string) => void;
}) {
  const [lastSearchesItems, setLastSearchesItems] = useState<React.ReactNode[]>([]);
  const userLocation = locationStore.selectedLocation;

  useEffect(() => {
    if (lastSearches) {
      const items = lastSearches?.map((text) => {
        const query = convertObjectToQueryParam({
          s: text,
        });
        return (
          <Link
            key={text}
            onClick={() => {
              closedDropdown();
              if (updateLastSearches) updateLastSearches(text);
            }}
            className={styles.lastSearchesText}
            href={createLinkToRedirect({
              param: query,
              routeType: 'search-bar-default-filter',
              userLocation,
            })}
          >
            <IconTime width={20} height={20} />
            {text}
          </Link>
        );
      });
      setLastSearchesItems(items);
    }
  }, [lastSearches]);

  return (
    <>
      <p className={styles.searchListTitle}>Sugestões</p>
      <div className={styles.searchEmptyListContainer}>
        {searchEmptyList?.map((item) => (
          <Link
            className={styles.searchDefaultText}
            href={createLinkToRedirect({
              item: {
                date: item?.dateId,
                urn: '',
              },
              param: `?d=${item?.param}`,
              routeType: 'search-bar-default-filter',
              userLocation,
            })}
            onClick={() => closedDropdown()}
            aria-label={item.label}
            key={item.label}
          >
            {`${userLocation?.slug ? `Em ${userLocation?.city}` : ''} ${item.label}`}
          </Link>
        ))}
      </div>
      {lastSearchesItems.length > 0 && <p className={`${styles.searchListTitle} ${styles.paddingTitle}`}>Pesquisas recentes</p>}
      {lastSearchesItems}
    </>
  );
}

export default SearchEmptyList;
